export const ROLE_ADJUSTMENT = 'ADJUSTMENT';
export const ROLE_CONTROL = 'CONTROL';
export const ROLE_MACHINE = 'MACHINE';
export const ROLE_CAD = 'CAD';
export const ROLE_CAM = 'CAM';
export const ROLE_CM = 'CM';
export const ROLE_MANAGEMENT = 'MANAGEMENT';
export const ROLE_PURCHASING = 'PURCHASING';
export const ROLE_WAREHOUSE = 'WAREHOUSE';
export const ROLE_COMMERCIAL = 'COMMERCIAL';
export const ROLE_ADMIN = 'ADMIN';
export const PRIVILEGE_SA = 'SA';



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/config/roles.config.ts